<template>
  <v-layout wrap justify-center class="pa-6">
    <v-flex xs12 md12>
      <v-card class="mx-auto col-12" max-width="1300" elevation="2">
        <v-card-title>
          <v-list-item>
            <v-list-item-icon>
              <v-icon size="30" color="blue darken-4 "
                >mdi-cart-arrow-down</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >XXCargue de Facturas</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-card-title>
        <div class="pa-0 px-8">
          <v-card-text class="px-0 pa-0">
            <v-row>
              <v-col class="d-flex" cols="12" sm="6">
                <v-autocomplete
                  outlined
                  label="Contrato"
                  :items="contratos"
                  :item-text="format_contrato"
                  item-value="nro"
                  hide-details
                  :loading="load_contrato"
                  v-model="selectContrato"
                  clearable
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col class="d-flex" cols="12" sm="3">
                <v-menu
                  v-model="pickerIniCargue"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_inicargue"
                      label="Fecha Inicial de Cargue"
                      append-icon="event"
                      hide-details
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha_inicargue"
                    @input="pickerIniCargue = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="d-flex" cols="12" sm="3">
                <v-menu
                  v-model="pickerFinCargue"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_fincargue"
                      label="Fecha Final de Cargue"
                      append-icon="event"
                      hide-details
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha_fincargue"
                    @input="pickerFinCargue = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

            </v-row>
            <v-row>
              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  outlined
                  label="Tipo de Cargue"
                  :items="[
                    { text: 'Factura por Paciente', value: '1' },
                    { text: 'MultiPacientes', value: '2' }
                  ]"
                  v-model="selectTipo"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-menu
                  v-model="pickerActual"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_actual"
                      label="Fecha de la Factura"
                      append-icon="event"
                      hide-details
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha_actual"
                    @input="pickerActual = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-btn
                  color="indigo"
                  class="ma-2 white--text"
                  @click="get_facturas"
                >
                  Generar
                  <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  label="Factura Inicial"
                  v-model="fact_ini"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  label="Factura Final"
                  v-model="fact_fin"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import post from "../../methods.js";
export default {
  data() {
    return {
      condition: false,
      search: null,
      servicio: "Imagenologia",
      pickerIniCargue: false,
      pickerFinCargue: false,      
      fecha_cargue: this.$moment().format("YYYY-MM"),
      load_contrato: true,
      load_table: false,
      pickerActual: false,
      selectContrato: null,
      selectTipo: null,
      fecha_factura: null,
      fact_ini: null,
      fact_fin: null,
      fecha_actual: this.$moment().format("YYYY-MM-DD"),
      nameRules: [
        v => !!v || "Campo obligatorio",
        v => (v && v.length <= 60) || "Maximo 20 digitos"
      ],
      contratos: [],
      form: [],
      headers: [
        { text: "Nro", align: "center", value: "nro" },
        {
          text: "Descripcion paciente",
          align: "center",
          value: "descrip_paciente"
        },
        { text: "Descripcion", align: "center", value: "desc_servicio" },
        { text: "Fecha", align: "center", value: "fecha" },
        { text: "Hora", align: "center", value: "id_hora" },
        {
          text: "Identificacion paciente",
          align: "center",
          value: "id_paciente"
        },
        { text: "Opciones", value: "edit", align: "center" }
      ]
    };
  },
  created() {
    this.cargarContratos();
    this.fecha_inicargue = this.$moment().format("YYYY-MM-01");
    this.fecha_fincargue = this.$moment().format("YYYY-MM-01");    

  },

  computed: {
    descripContrato() {
      if (this.selectContrato == null) return undefined;
      let retornar = this.contratos.filter(e => {
        if (e.nro == this.selectContrato) {
          return e.descripcion;
        }
      });
      return retornar[0].descripcion;
    }
  },
  methods: {
    format_contrato(val) {
      return val.nro + " - " + val.descripcion + "-" + val.detalle;
    },
    cargarContratos() {
      post
        .postData({
          url: "Clinico/dlls/titcl304jl.dll",
          data: sessionStorage.Sesion + "|",
          method: ""
        })
        .then(data => {
          this.contratos = data;
          this.load_contrato = false;
        })
        .catch(err => {
          this.load_contrato = false;
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar contratos",
            estado: true
          });
        });
    },
    get_facturas() {
      let datos =
        sessionStorage.Sesion +
        "|" +
        "01|" +
        this.selectContrato.identificacion +
        "|" +
        this.selectTipo +
        "|" +
        this.fecha_inicargue.split("-").join("") +
        "|" +
        this.fecha_fincargue.split("-").join("") +
        "|" +
        this.fecha_actual.split("-").join("") +
        "|" +
        this.selectContrato.nro +
        "|0|";
      post
        .postData({
          url: "Clinico/dlls/titcl103.dll",
          data: datos,
          method: ""
        })
        .then(data => {
          let resp = data[0].split("|");
          this.fact_ini = resp[0];
          this.fact_fin = resp[1];
        })
        .catch(err => {
          console.log(err);
          this.load_contrato = false;
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar facturas",
            estado: true
          });
        });
    }
  }
};
</script>
